export const SLACK_LINK_START_PATH = "/slack_oauth/link";

export const SLACK_LINK_GENERIC_ERROR = "Something went wrong. Please try again.";

export const SLACK_NO_WORKSPACE_ERROR_CODE = "no_workspace";

export const SLACK_LINK_ERROR_MESSAGES: Record<string, string> = {
  already_claimed: "This Slack account is already linked to another Spacelift user.",
  [SLACK_NO_WORKSPACE_ERROR_CODE]: "Your organization hasn't connected a Slack workspace yet.",
  workspace_mismatch:
    "This Slack account belongs to a different workspace than the one connected to your organization.",
};
